module.exports = __webpack_public_path__ + "img/Westgate_234.cface8e2.jpeg";